var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            { attrs: { size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("orderCenterCont.DateBusiness"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "picker-options": _vm.pickerOptions,
                              "range-separator": _vm.$t("operationCenter.to"),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "popper-class": "dateTimeClass",
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                            },
                            on: { blur: _vm.refreshDate },
                            model: {
                              value: _vm.dateArr,
                              callback: function ($$v) {
                                _vm.dateArr = $$v
                              },
                              expression: "dateArr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("orderCenterCont.customer"),
                            prop: "region",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getUserOption,
                              },
                              on: {
                                "visible-change": function ($event) {
                                  return _vm.getUserOption()
                                },
                              },
                              model: {
                                value: _vm.queryForm.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "customerId", $$v)
                                },
                                expression: "queryForm.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "（" +
                                    item.username +
                                    "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t(
                              "receivablePayable.WhetherToCheckOrNot"
                            ),
                            prop: "region",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.isAccept,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "isAccept", $$v)
                                },
                                expression: "queryForm.isAccept",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.yes"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.No"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t(
                              "receivablePayable.WhetherToGenerateAStatement"
                            ),
                            prop: "region",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.isGenBill,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "isGenBill", $$v)
                                },
                                expression: "queryForm.isGenBill",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.yes"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.No"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getData } },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showResetData = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.刷新数据")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "box-card" }, [
                    _c("div", { staticStyle: { "font-size": "16px" } }, [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("collectionCenter.lanshou")) + "-"
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("compensationManagement.TotalNumberOfVotes")
                          ) +
                          "： "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.collectingVotes))]),
                      _vm._v(", "),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("compensationManagement.TotalAmount")) +
                          "： "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.collectingAmount))]),
                    ]),
                    _c("div", {
                      staticStyle: {
                        width: "100%",
                        height: "calc(100vh - 450px)",
                      },
                      attrs: { id: "collecting" },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "box-card" }, [
                    _c("div", { staticStyle: { "font-size": "16px" } }, [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("collectionCenter.expressDelivery")) +
                            "-"
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("compensationManagement.TotalNumberOfVotes")
                          ) +
                          "： "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.expressVotes))]),
                      _vm._v(", "),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("compensationManagement.TotalAmount")) +
                          "： "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.expressAmount))]),
                    ]),
                    _c("div", {
                      staticStyle: {
                        width: "100%",
                        height: "calc(100vh - 450px)",
                      },
                      attrs: { id: "express" },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showResetData,
            title: _vm.$t("basicData.刷新数据"),
            width: "400px",
            "append-to-body": "",
            "modal-append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showResetData = $event
            },
            close: _vm.closeResetWindow,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  key: _vm.showResetData,
                  ref: "resetDataForm",
                  attrs: { model: _vm.resetDataForm, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.Date"),
                        prop: "resetDataDate",
                        rules: [
                          {
                            required: true,
                            message: _vm.$t(
                              "collectionCenter.PleaseSelectTime"
                            ),
                            trigger: ["change", "blur"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: _vm.$t(
                            "collectionCenter.PleaseSelectTime"
                          ),
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.resetDataForm.resetDataDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.resetDataForm, "resetDataDate", $$v)
                          },
                          expression: "resetDataForm.resetDataDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmRefresh },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }